import React, {useEffect, useRef, useState} from 'react';
import {ChevronDownIcon} from '@heroicons/react/24/solid';
import styles from './MultiSelect.module.css';

interface Option {
    value: number;
    label: string;
}

interface MultiSelectProps {
    options: Option[];
    value: number[];
    onChange: (selected: number[]) => void;
    placeholder?: string;
}

// 다중 선택 컴포넌트
const MultiSelect: React.FC<MultiSelectProps> = ({
                                                     options,
                                                     value,
                                                     onChange,
                                                     placeholder = '선택해주세요'
                                                 }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleOptionClick = (optionValue: number) => {
        const newValue = value.includes(optionValue)
            ? value.filter(v => v !== optionValue)
            : [...value, optionValue];
        onChange(newValue);
    };

    // 선택된 아이템 표시, 3개 이상 선택 시 3번쨰 아이템부터는 '외 n개로' 표시
    const getDisplayValue = () => {
        if (value.length === 0) return placeholder;
        const selectedLabels = value
            .map(v => options.find(opt => opt.value === v)?.label)
            .filter(Boolean);

        if (selectedLabels.length > 2) {
            return `${selectedLabels[0]}, ${selectedLabels[1]} 외 ${selectedLabels.length - 2}개`;
        }
        return selectedLabels.join(', ');
    };

    useEffect(() => {
        // 외부 클릭 시 선택 창 닫음
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className={styles.container} ref={dropdownRef}>
            {/*아이템 드롭 다운 버튼*/}
            <button
                type="button"
                className={styles.selectButton}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className={styles.selectText}>{getDisplayValue()}</span>
                <ChevronDownIcon
                    className={`${styles.icon} ${isOpen ? styles.iconOpen : ''}`}
                />
            </button>
            {isOpen && (
                // 아이템
                <div className={styles.dropdown}>
                    {options.map((option) => (
                        <label key={option.value} className={styles.option}>
                            {/*선택*/}
                            <input
                                type="checkbox"
                                checked={value.includes(option.value)}
                                onChange={() => handleOptionClick(option.value)}
                                className={styles.checkbox}
                            />
                            <span className={styles.optionLabel}>{option.label}</span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MultiSelect;